import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedCompany: null,
};

const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    setSelectedCompany: (state, action) => {
      state.selectedCompany = action.payload;

    },
    clearSelectedCompany: (state) => {
      state.selectedCompany = null;
    },
  },
});

export const { setSelectedCompany, clearSelectedCompany } = companySlice.actions;
export default companySlice.reducer;